import { createTheme } from '@mui/material/styles';

// Tema accesible para audiencia 18–90 años.
// Escala tipográfica: body1=18px, body2=16px, caption=14px (WCAG 2.1 AA).
// Contraste primario: #1565c0 → 4.7:1 sobre blanco (supera el mínimo 4.5:1 de WCAG AA).
// Área táctil mínima: 48px en botones, 88px en cards de selector (WCAG 2.5.5).
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1565c0',
    },
    secondary: {
      main: '#c62828',
    },
    background: {
      default: '#f4f6f8',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1a2e',    // Contraste 17:1 sobre blanco
      secondary: '#424242',  // Contraste 9.7:1 sobre blanco
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    body1:    { fontSize: '1.125rem' },   // 18px
    body2:    { fontSize: '1rem' },       // 16px
    caption:  { fontSize: '0.875rem' },   // 14px
    subtitle1: { fontSize: '1.125rem', fontWeight: 500 },
    subtitle2: { fontSize: '1rem',     fontWeight: 600 },
    h4: { fontSize: '1.75rem',  fontWeight: 700 },
    h5: { fontSize: '1.375rem', fontWeight: 700 },
    h6: { fontSize: '1.125rem', fontWeight: 700 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 48,
          borderRadius: 8,
          textTransform: 'none',
          fontSize: '1rem',
          fontWeight: 600,
        },
        sizeLarge: {
          minHeight: 56,
          fontSize: '1.125rem',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          minWidth: 44,
          minHeight: 44,
        },
      },
    },
    MuiCardActionArea: {
      styleOverrides: {
        root: {
          minHeight: 88,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        message: {
          fontSize: '0.9375rem',
        },
      },
    },
  },
});

export default theme;
